/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MetaJungle, MetaJungleInterface } from "../MetaJungle";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "ensRegistryAddr",
        type: "address",
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "payees",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "shares",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
        ],
        indexed: false,
        internalType: "struct Jungler.JunglerData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "CurrentJunglerState",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "bushId",
        type: "uint8",
      },
    ],
    name: "camp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "close",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "gank",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "generation",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAddrOfJGR",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllProposals",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "proposer",
            type: "address",
          },
          {
            internalType: "string",
            name: "baseURI",
            type: "string",
          },
          {
            internalType: "uint88",
            name: "bid",
            type: "uint88",
          },
          {
            internalType: "uint8",
            name: "voteCount",
            type: "uint8",
          },
        ],
        internalType: "struct JungleGovernance.Proposal[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "getJunglerData",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
        ],
        internalType: "struct Jungler.JunglerData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "bushId",
        type: "uint8",
      },
    ],
    name: "getJunglerOnBush",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
        ],
        internalType: "struct Jungler.JunglerData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
    ],
    name: "getJunglerProfile",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
          {
            internalType: "string",
            name: "tokenURI",
            type: "string",
          },
        ],
        internalType: "struct MetaJungle.JunglerProfile",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "bushId",
        type: "uint8",
      },
    ],
    name: "getJunglerProfileOnBush",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
          {
            internalType: "string",
            name: "tokenURI",
            type: "string",
          },
        ],
        internalType: "struct MetaJungle.JunglerProfile",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "getOwnerJunglerList",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "generation",
            type: "uint32",
          },
          {
            internalType: "bool",
            name: "isOpen",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isCampping",
            type: "bool",
          },
          {
            internalType: "int40",
            name: "power",
            type: "int40",
          },
          {
            internalType: "address",
            name: "proxy",
            type: "address",
          },
          {
            internalType: "int256",
            name: "openPrice",
            type: "int256",
          },
          {
            internalType: "int8",
            name: "leverage",
            type: "int8",
          },
          {
            internalType: "string",
            name: "tokenURI",
            type: "string",
          },
        ],
        internalType: "struct MetaJungle.JunglerProfile[]",
        name: "junglerList",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "getVotableBushesByOwner",
    outputs: [
      {
        internalType: "uint8[]",
        name: "bushIdList",
        type: "uint8[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "junglerId",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "namehash",
        type: "bytes32",
      },
      {
        internalType: "int8",
        name: "leverage",
        type: "int8",
      },
    ],
    name: "open",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "slotId",
        type: "uint8",
      },
    ],
    name: "propose",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stage",
    outputs: [
      {
        internalType: "enum JungleBush.Stage",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startVote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "summon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8[]",
        name: "bushIdList",
        type: "uint8[]",
      },
    ],
    name: "vote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class MetaJungle__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    ensRegistryAddr: string,
    baseURI: string,
    payees: string[],
    shares: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MetaJungle> {
    return super.deploy(
      ensRegistryAddr,
      baseURI,
      payees,
      shares,
      overrides || {}
    ) as Promise<MetaJungle>;
  }
  getDeployTransaction(
    ensRegistryAddr: string,
    baseURI: string,
    payees: string[],
    shares: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      ensRegistryAddr,
      baseURI,
      payees,
      shares,
      overrides || {}
    );
  }
  attach(address: string): MetaJungle {
    return super.attach(address) as MetaJungle;
  }
  connect(signer: Signer): MetaJungle__factory {
    return super.connect(signer) as MetaJungle__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MetaJungleInterface {
    return new utils.Interface(_abi) as MetaJungleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaJungle {
    return new Contract(address, _abi, signerOrProvider) as MetaJungle;
  }
}
